import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { getImgUrl } from 'modules/media';

export const ProductImage: FC<{
  hash?: string;
  alt?: string;
  className?: string;
  onClick?: () => void;
}> = ({ hash, alt, className, onClick }) => {
  const src = hash && getImgUrl(hash);

  return <Image className={className} src={src} alt={alt} onClick={onClick} />;
};
